export const initializeDOMReady = (callbacks: (() => void)[]): void => {
  document.addEventListener("DOMContentLoaded", () => {
    callbacks.forEach((callback) => callback());
  });
};
